import React from 'react'
import {HStack, Text, Spacer, useStyleConfig, Box} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import SuccessIcon from '../icons/SuccessIcon'
import WarningIcon from '../icons/WarningIcon'
import CloseIcon from '../icons/action/CloseIcon'

function Feedback({
    status = 'success',
    message,
    description,
    onClose,
    action,
    variant = 'success',
    enableIcon = true,
}) {
    const styles = useStyleConfig('Feedback', {status, variant})

    let icon = null
    if (status !== null || status !== undefined) {
        icon =
            status === 'success' ? (
                <SuccessIcon {...styles?.statusIcon} data-testid="status-icon" />
            ) : (
                <WarningIcon {...styles?.statusIcon} data-testid="status-icon" />
            )
    }
    return (
        <Box {...styles.container}>
            <HStack {...styles?.innerContainer}>
                {enableIcon ? icon : <></>}
                <Text>{message}</Text>
                <Spacer />
                <CloseIcon
                    {...styles?.closeIcon}
                    onClick={onClose}
                    data-testid="feedback-close-icon"
                />
            </HStack>
            {description && <Text {...styles.text}>{description}</Text>}
            {typeof action === 'string' ? {action} : action}
        </Box>
    )
}

Feedback.propTypes = {
    variant: PropTypes.string,
    message: PropTypes.string,
    description: PropTypes.string,
    onClose: PropTypes.func,
    action: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    status: PropTypes.string,
    enableIcon: PropTypes.bool,
}

export default Feedback
